import * as React from 'react'
import {Util} from 'yougile-util'

interface InputModel {
  ref: (el: HTMLInputElement) => void
  get: () => string
}

export const makeInputModel = (): InputModel => {
  let inputEl: HTMLInputElement
  return {
    ref: (el: HTMLInputElement) => (inputEl = el),
    get: (): string => (inputEl ? inputEl.value || '' : '')
  }
}

interface Props {
  value?: string
  placeholder?: string
  onChange?: (value: string) => void
  className?: string
  type?: string
  isValid?: (value: string) => boolean
  model?: InputModel
  onEnter?: () => void
  onEscape?: () => void
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void
  defaultValue?: string
  large?: boolean
}

export const Input = (props: Props) => {
  const {
    value,
    className = '',
    onChange = Util.noop,
    placeholder,
    type = 'text',
    isValid,
    model,
    onEnter,
    onEscape,
    onFocus,
    defaultValue,
    large
  } = props
  const bem = Util.bemFrom('input-control')
  const change = (e: React.ChangeEvent<HTMLInputElement>) =>
    onChange(e.target.value)

  const keydown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && onEnter) {
      onEnter()
    } else if (e.key === 'Escape' && onEscape) {
      onEscape()
    }
  }

  const valid = isValid ? isValid(value) : true
  const invalidClass = !valid ? ['invalid'] : []
  const largeClass = large ? ['large'] : []

  return (
    <input
      className={bem([className, ...invalidClass, ...largeClass])}
      value={value}
      defaultValue={defaultValue}
      placeholder={placeholder}
      onChange={change}
      type={type}
      onKeyDown={keydown}
      onFocus={onFocus}
      autoFocus={!!onFocus}
      {...(model ? {ref: model.ref} : {})}
    />
  )
}
